import React, { useState } from "react"
import { Paper, Grid } from "@material-ui/core"
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  InputCheckboxMaster,
  InputAsyncOptionMaster,
} from "App/Component/ui"

import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
  TYPE_INSTANCE3,
  TYPE_INSTANCE4,
  TYPE_SATU_SEHAT_V2,
} from "App/constants"

import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  convertToValidPrice,
  isNull,
  fetchData,
} from "App/utils/helpers"

import { STYLE_JENIS_LAYANAN } from "App/Component/layout/MasterData/JenisLayanan/ui"
import {
  RESET_STATE_JASA,
  urlCreate,
  urlGetJenisJasa,
  urlUpdate,
  urlUpdateAll,
} from "."
import { useSelectOption } from "App/hooks"
import { WarningMasterPenjualan } from "../../helperMasterPenjualan"
import { SelectIcon } from "App/Assets"
import ModalTemplate from "./ModalTemplate"

export const DEFAULT_SHOW_BUTTON_ALL = {
  label: "Update All",
  color: "warning",
  state: false,
}

export default function FormJasa({
  formData,
  setFormData,
  setNewData,

  formHargaTarifBeli,
  setFormHargaTarifBeli,

  formHargaTarifJual,
  setFormHargaTarifJual,

  fieldTarif,
  resetFormHargaTarifBeli,
  resetFormHargaTarifJual,

  jasaID,
  setJasaID,

  dataTarif,
}) {
  const classes = STYLE_JENIS_LAYANAN()
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const [showModalTemplate, setShowModalTemplate] = useState(false)

  const [disabledUpdateAll, setDisabledUpdateAll] = useState(
    DEFAULT_SHOW_BUTTON_ALL,
  )

  const preLoadData = async (inputValue) => {
    const res = await fetchData(
      TYPE_SATU_SEHAT_V2,
      "/satu-sehat/master/snomed/resource",
      "data",
      {
        params: {
          pages: 1,
          limit: 30,
          search_key: isNull(inputValue) ? "" : inputValue,
        },
      },
      "list",
    )

    if (res) {
      return res;
    }
  }

  const jenisJasa = useSelectOption(
    false,
    urlGetJenisJasa,
    TYPE_INSTANCE3,
    "id",
    "info",
  )

  const jenisHarga = useSelectOption(
    false,
    "/wmsfarmasi/master/harga/list",
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )

  const setValidHarga = (hargaBeli, hargaJual) => {
    const validHarga = []
    fieldTarif.map((item) => {
      const hj = hargaJual.find((x) => x.id_tarif === item.id)
      const hb = hargaBeli.find((x) => x.id_tarif === item.id)

      if (isNull(jasaID)) {
        validHarga.push({
          id_tarif: item.id,
          harga_beli: isNull(hb) ? 0 : convertToValidPrice(hb.harga_beli),
          harga_jual: isNull(hj) ? 0 : convertToValidPrice(hj.harga_jual),
        })
      } else {
        const findMsHarga = formData.harga.find((e) => e.id_tarif === item.id)
        validHarga.push({
          id_tarif: item.id,
          harga_beli: isNull(hb) ? 0 : convertToValidPrice(hb.harga_beli),
          harga_jual: isNull(hj) ? 0 : convertToValidPrice(hj.harga_jual),
          id: findMsHarga.id,
        })
      }

      return true
    })

    return validHarga
  }

  const tarifCBG = useSelectOption(
    true,
    "/wmsfarmasi/master/tarifCbg/list",
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const changeTarifBeli = (id) => (e) => {
    const exceptPrice = formHargaTarifBeli.filter((row) => row.id_tarif !== id)

    setFormHargaTarifBeli([
      ...exceptPrice,
      {
        id_tarif: id,
        harga_beli2: formatRupiah(e.target.value),
        harga_beli: convertToValidPrice(e.target.value),
      },
    ])
  }

  const changeTarifJual = (id) => async (e) => {
    const exceptPrice = formHargaTarifJual.filter((row) => row.id_tarif !== id)
    setFormHargaTarifJual([
      ...exceptPrice,
      {
        id_tarif: id,
        harga_jual2: formatRupiah(e.target.value),
        harga_jual: convertToValidPrice(e.target.value),
      },
    ])
  }

  const resetForm = () => {
    setFormData(RESET_STATE_JASA)
    setFormHargaTarifBeli(resetFormHargaTarifBeli)
    setFormHargaTarifJual(resetFormHargaTarifJual)
    setJasaID("")
  }

  const addJasa = async (harga) => {
    const data = {
      nama: formData.nama,
      id_jenis_jasa: formData.id_jenis_jasa,
      harga,
      status: formData.status,
      id_tarif_cbg: formData.id_tarif_cbg,

      is_emr: formData.is_emr,
      is_rajal: formData.is_rajal,
      is_ranap: formData.is_ranap,
      is_igd: formData.is_igd,
      is_perawat: formData.is_perawat,
      id_template: isNull(formData.id_template) ? 0 : formData.id_template,
      nama_template: formData.nama_template,
      kode_snomed: formData?.kode_snomed?.value ?? "",
    }

    return instance3.post(urlCreate, data)
  }

  const updateJasa = async (harga) => {
    const data = {
      id: jasaID,
      nama: formData.nama,
      id_jenis_jasa: formData.id_jenis_jasa,
      harga,
      id_msHarga: formData.id_jenis_harga,
      status: formData.status,
      id_tarif_cbg: formData.id_tarif_cbg,

      is_emr: formData.is_emr,
      is_rajal: formData.is_rajal,
      is_ranap: formData.is_ranap,
      is_igd: formData.is_igd,
      is_perawat: formData.is_perawat,
      id_template: isNull(formData.id_template) ? 0 : formData.id_template,
      nama_template: formData.nama_template,
      kode_snomed: formData?.kode_snomed?.value ?? "",
    }

    return instance3.post(urlUpdate, data)
  }

  const updateAll = async (harga) => {
    const data = {
      id: jasaID,
      nama: formData.nama,
      id_jenis_jasa: formData.id_jenis_jasa,
      harga,
      status: formData.status,
      id_tarif_cbg: formData.id_tarif_cbg,

      is_emr: formData.is_emr,
      is_rajal: formData.is_rajal,
      is_ranap: formData.is_ranap,
      is_igd: formData.is_igd,
      is_perawat: formData.is_perawat,
      id_template: isNull(formData.id_template) ? 0 : formData.id_template,
      nama_template: formData.nama_template,
      kode_snomed: formData?.kode_snomed?.value ?? "",
    }

    return instance3.post(urlUpdateAll, data)
  }

  const handleUpdateAll = async (e) => {
    e.preventDefault()
    setDisabledUpdateAll(DISABLED_BUTTON_SUBMIT)
    if (formData.nama === "") {
      setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL)
      defaultToastError("Nama tidak boleh kosong")
    }
    const checkInputHarga = validateHargaJualBeliJasa()
    if (checkInputHarga.stateValidate === false) {
      setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL)
      defaultToastError(checkInputHarga.messageValidate)
      return false
    }

    try {
      const newHarga = setValidHarga(formHargaTarifBeli, formHargaTarifJual)
      const res = await updateAll(newHarga)
      if (res.data.status === 200) {
        defaultToastSuccess("Berhasil mengubah jasa")
        resetForm()
        setNewData()
        setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL)
      } else {
        defaultToastError(res.data.message)
        setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL)
      }
    } catch (error) {
      setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const validateHargaJualBeliJasa = () => {
    let messageValidate = ""
    let stateValidate = true

    const dataFormHarga = fieldTarif
    const dataHargaBeli = formHargaTarifBeli
    const dataHargaJual = formHargaTarifJual
    /*
    Ada anomali pada saat di map, data yang dimap terbalik dimulai dari array terbesar validasi nya
    saat di short data state nya malah ikut ke ubah, secara urutan di form harga nya juga berubah
      .sort(function(a, b) {
        return b.id - a.id;
      })
    */
    dataFormHarga.map((item) => {
      // Cek Harga Beli
      const hargaBeli = dataHargaBeli.filter((row) => row.id_tarif === item.id)
      if (isNull(hargaBeli?.length ?? "") || hargaBeli?.length === 0) {
        messageValidate = `Harga Beli ${
          item?.name ?? "".toUpperCase()
        } Belum Diinput`
        stateValidate = false
        return false
      } else {
        if (isNull(hargaBeli[0]?.harga_beli2)) {
          messageValidate = `Harga Beli ${
            item?.name ?? "".toUpperCase()
          } Belum Diinput`
          stateValidate = false
          return false
        } else {
          // Tidak ngapa ngapain
        }
      }

      // Cek Harga Jual
      const hargaJual = dataHargaJual.filter((row) => row.id_tarif === item.id)
      if (isNull(hargaJual?.length ?? "") || hargaJual?.length === 0) {
        messageValidate = `Harga Jual ${
          item?.name ?? "".toUpperCase()
        } Belum Diinput`
        stateValidate = false
        return false
      } else {
        if (isNull(hargaJual[0]?.harga_jual2)) {
          messageValidate = `Harga Jual ${
            item?.name ?? "".toUpperCase()
          } Belum Diinput`
          stateValidate = false
          return false
        } else {
          // Tidak ngapa ngapain
        }
      }
      return true
    })

    return {
      messageValidate,
      stateValidate,
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)

    if (formData.nama === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError("Nama tidak boleh kosong")
    } else {
      try {
        const checkInputHarga = validateHargaJualBeliJasa()
        if (checkInputHarga.stateValidate === false) {
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          defaultToastError(checkInputHarga.messageValidate)
          return false
        }

        if (isNull(jasaID)) {
          const newHarga = setValidHarga(formHargaTarifBeli, formHargaTarifJual)
          const res = await addJasa(newHarga)
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil menambah jasa")
            resetForm()
            setNewData()
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
            defaultToastError(res.data.message)
          }
        } else {
          const newHarga = setValidHarga(formHargaTarifBeli, formHargaTarifJual)

          const res = await updateJasa(newHarga)

          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil mengubah jasa")
            resetForm()
            setNewData()
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            defaultToastError(res.data.message)
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          }
        }
      } catch (error) {
        console.log("error", error)
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        defaultToastError(error?.response?.data?.message)
      }
    }
  }

  const handleClickSelectTemplate = (row) => {
    setFormData({
      ...formData,
      id_template: row.id,
      nama_template: row.name,
    })
    setShowModalTemplate(false)
  }

  return (
    <>
      {showModalTemplate && (
        <ModalTemplate
          setShowModal={() => setShowModalTemplate(false)}
          handleClickSelect={handleClickSelectTemplate}
        />
      )}
      <Paper className={classes.paper}>
        <form onSubmit={(e) => handleSubmit(e)}>
          <Grid container spacing={1}>
            <Grid item sm={3}>
              <InputTextMaster
                name="id"
                label="ID"
                id="id"
                placeholder="-"
                readOnly={true}
                disabled={true}
                value={jasaID}
              />
            </Grid>
            <Grid item sm={3}>
              <InputTextMaster
                name="nama"
                label="NAMA"
                id="nama"
                autoFocus={true}
                value={formData.nama}
                onChange={handleChange("nama")}
                placeholder="Nama Jasa"
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name="id_jenis_jasa"
                label="JENIS JASA"
                id="id_jenis_jasa"
                withSearch={false}
                value={formData.id_jenis_jasa}
                data={jenisJasa}
                onChange={handleChange("id_jenis_jasa")}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name="id_jenis_harga"
                label="JENIS HARGA"
                id="id_jenis_harga"
                withSearch={false}
                disabled={isNull(formData.id_jenis_harga) ? false : true}
                value={formData.id_jenis_harga}
                data={jenisHarga}
                onChange={handleChange("id_jenis_harga")}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name="id_tarif_cbg"
                label="TARIF CBG"
                id="id_tarif_cbg"
                withSearch={true}
                data={tarifCBG}
                value={formData.id_tarif_cbg}
                labelValue={formData.tarif_cbg}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      id_tarif_cbg: null,
                      tarif_cbg: "Pilih CBG",
                    })
                  } else {
                    setFormData({
                      ...formData,
                      id_tarif_cbg: e.value,
                      tarif_cbg: e.label,
                    })
                  }
                }}
              />
            </Grid>

            <Grid item xs={3}>
              <div
                style={{
                  display: "flex",
                }}
              >
                <InputTextMaster
                  name="id_template"
                  label="TEMPLATE"
                  id="id_template"
                  placeholder="Template"
                  value={formData.id_template}
                  onChange={handleChange("id_template")}
                />

                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name=""
                  size="sm"
                  withIcon={true}
                  onClick={() => setShowModalTemplate(!showModalTemplate)}
                  style={{
                    marginTop: "1.5rem",
                    width: "32px",
                    height: "32px",
                  }}
                  icon={
                    <SelectIcon
                      width="16px"
                      height="16px"
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </div>
            </Grid>

            <Grid item xs={3}>
              <InputAsyncOptionMaster
                name="kode_snomed"
                label="KODE SNOMED"
                id="kode_snomed"
                loadOptions={preLoadData}
                data={preLoadData}
                withSearch
                value={formData?.kode_snomed?.value}
                labelValue={formData?.kode_snomed?.label}
                // defaultData={formData.jasa}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      kode_snomed: null,
                    })
                  } else {
                    setFormData({
                      ...formData,
                      kode_snomed: e,
                    })
                  }
                }}
              />
            </Grid>

            <Grid item sm={6}>
              <Grid
                container
                justifyContent="space-between"
                style={{
                  marginLeft: "1rem",
                  marginTop: "0.5rem",
                }}
              >
                <Grid item>
                  <div className="pt-1">
                    <InputCheckboxMaster
                      checked={formData.is_emr}
                      name="is_emr"
                      id="is_emr"
                      label="EMR"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                      onChange={() =>
                        setFormData({ ...formData, is_emr: !formData.is_emr })
                      }
                    />
                  </div>
                </Grid>

                <Grid item>
                  <div className="pt-1">
                    <InputCheckboxMaster
                      checked={formData.is_rajal}
                      name="is_rajal"
                      id="is_rajal"
                      label="RAJAL"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                      onChange={() =>
                        setFormData({
                          ...formData,
                          is_rajal: !formData.is_rajal,
                        })
                      }
                    />
                  </div>
                </Grid>

                <Grid item>
                  <div className="pt-1">
                    <InputCheckboxMaster
                      checked={formData.is_ranap}
                      name="is_ranap"
                      id="is_ranap"
                      label="RANAP"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                      onChange={() =>
                        setFormData({
                          ...formData,
                          is_ranap: !formData.is_ranap,
                        })
                      }
                    />
                  </div>
                </Grid>

                <Grid item>
                  <div className="pt-1">
                    <InputCheckboxMaster
                      checked={formData.is_igd}
                      name="is_igd"
                      id="is_igd"
                      label="IGD"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                      onChange={() =>
                        setFormData({ ...formData, is_igd: !formData.is_igd })
                      }
                    />
                  </div>
                </Grid>

                <Grid item>
                  <div className="pt-1">
                    <InputCheckboxMaster
                      checked={formData.is_perawat}
                      name="is_perawat"
                      id="is_perawat"
                      label="PERAWAT"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                      onChange={() =>
                        setFormData({
                          ...formData,
                          is_perawat: !formData.is_perawat,
                        })
                      }
                    />
                  </div>
                </Grid>

                <Grid item>
                  <div className="pt-1">
                    <InputCheckboxMaster
                      checked={formData.status}
                      name="status"
                      id="status"
                      label="Aktif"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                      onChange={() =>
                        setFormData({ ...formData, status: !formData.status })
                      }
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <p className="fw-600 mt-2">HARGA</p>
          <div className="mt-1">
            <Grid container spacing={3}>
              {fieldTarif.map((e, index) => {
                const hargaBeli = formHargaTarifBeli.find(
                  (row) => row.id_tarif === e.id,
                )
                const indexHargaBeli = formHargaTarifBeli.indexOf(hargaBeli)

                const hargaJual = formHargaTarifJual.find(
                  (row) => row.id_tarif === e.id,
                )
                const indexHargaJual = formHargaTarifJual.indexOf(hargaJual)

                return (
                  <Grid item sm={3} key={index}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label
                        className="form-control-label"
                        htmlFor={`price-${e.id}`}
                      >
                        {e.name.toUpperCase()}
                      </label>
                      <div
                        id={`price-${e.id}`}
                        style={{
                          display: "flex",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Harga Beli"
                          className="form-control text"
                          style={{
                            borderTopRightRadius: "0",
                            borderBottomRightRadius: "0",
                          }}
                          onChange={changeTarifBeli(e.id)}
                          value={
                            formHargaTarifBeli[indexHargaBeli]?.harga_beli2
                          }
                        />
                        <input
                          type="text"
                          placeholder="Harga Jual"
                          className="form-control text"
                          style={{
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                          }}
                          value={
                            formHargaTarifJual[indexHargaJual]?.harga_jual2
                          }
                          onChange={changeTarifJual(e.id)}
                        />
                      </div>
                    </div>
                  </Grid>
                )
              })}
            </Grid>
          </div>

          <div className="mt-2">
            <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              spacing={2}
              alignItems="center"
            >
              <MasterButton
                outline={true}
                type={"button"}
                color="danger"
                name="Reset"
                size="md"
                onClick={() => resetForm()}
              />

              <div>
                {!isNull(jasaID) && (
                  <MasterButton
                    outline={false}
                    type={"button"}
                    style={{
                      marginRight: "0.5rem",
                    }}
                    onClick={handleUpdateAll}
                    color={disabledUpdateAll.color}
                    name={disabledUpdateAll.label}
                    size="md"
                  />
                )}
                <MasterButton
                  outline={false}
                  type={"submit"}
                  color={disabled.color}
                  name={disabled.label}
                  size="md"
                />
              </div>
            </Grid>

            <WarningMasterPenjualan />
          </div>
        </form>
      </Paper>
    </>
  )
}
